import axios from 'axios'
import type { AxiosPromise } from 'axios'

const ApiService = {
  init(baseURL: string): void {
    axios.defaults.baseURL = baseURL
  },

  setHeader(): void {
    axios.defaults.xsrfCookieName = 'csrftoken'
    axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN'
    axios.defaults.withCredentials = true
  },

  removeHeader(): void {
    axios.defaults.headers.common = {}
  },

  get: (url: string, config: Record<string, unknown>, version = 'v2'): AxiosPromise =>
    axios.get(`${version}${url}`, config),

  post: <T>(url: string, body: T, config: Record<string, unknown>, version = 'v2'): AxiosPromise =>
    axios.post(`${version}${url}`, body, config),

  put: (url: string, body: Record<string, unknown>, version = 'v2'): AxiosPromise =>
    axios.put(`${version}${url}`, body),

  patch: <T>(url: string, body: T, config: Record<string, unknown>, version = 'v2'): AxiosPromise =>
    axios.patch(`${version}${url}`, body, config),

  delete: (url: string, body?: Record<string, unknown>, version = 'v2'): AxiosPromise =>
    axios.delete(`${version}${url}`, { data: body })
}

function getCsrfToken(): string | undefined {
  const value = `; ${document.cookie}`
  const parts = value.split(`; csrftoken=`)
  if (parts.length === 2) return parts.pop()?.split(';').shift()
}

axios.interceptors.request.use(
  (config) => {
    const csrfToken = getCsrfToken()
    if (csrfToken) {
      config.headers['X-CSRFTOKEN'] = csrfToken
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default ApiService
